import React from "react";
import "./listcardleft.css";
import moment from "moment";
import { IMAGE_PATH } from "../../Utils/variables";

const ListCardLeft = ({
  closing_date,
  rfq_title,
  activeTabId,
  itemId,
  name,
}) => {
  return (
    <div
      className="listCardLeftMainDiv"
      id={activeTabId === itemId ? "activeList" : ""}
    >
      <div className=" listCardLeftMainDivMainName">{rfq_title}</div>
      <div className="listCardLeftBottom">
        <div className="listCardDiv1">
          <img
            src={
              activeTabId == itemId
                ? IMAGE_PATH + "carbonBuilding.png"
                : "./images/stratum/carbonBuildingInactive.png"
            }
            alt=""
          />
          <span className="listCompNameDiv">{name}</span>
        </div>
        <div>
          <div className="closingOnList">CLOSING ON</div>
          <div className="closingOnListDate">
            {moment(closing_date).format("DD MMM YYYY")}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ListCardLeft;
